import React, { useEffect, useState, useCallback } from 'react';
import { Image, Space, Spin, Empty, Popconfirm, Button, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { listHallazgoImagenes, deleteHallazgoImagen } from 'api/hallazgoImagenes';

// Galería de fotos de un hallazgo. refreshKey fuerza recarga cuando el parent
// sube una foto nueva. editable habilita el borrado.
// onCount(n) — callback opcional; se llama con la cantidad de fotos cargadas
// para que el parent pueda alimentar currentCount en HallazgoFotosUpload.
function HallazgoFotosGallery({ idHallazgo, refreshKey = 0, editable = false, onCount }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    if (!idHallazgo) return;
    setLoading(true);
    listHallazgoImagenes(idHallazgo)
      .then((data) => {
        setItems(data);
        onCount?.(data.length);
      })
      .catch(() => {
        setItems([]);
        onCount?.(0);
      })
      .finally(() => setLoading(false));
  }, [idHallazgo, onCount]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  const handleDelete = async (imagenId) => {
    try {
      await deleteHallazgoImagen(idHallazgo, imagenId);
      message.success('Foto eliminada');
      load();
    } catch (err) {
      message.error(err?.message || 'No se pudo eliminar');
    }
  };

  if (loading) return <Spin />;
  if (!items.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin fotos" />;

  return (
    <Image.PreviewGroup>
      <Space wrap>
        {items.map((it) => (
          <div key={it.id} style={{ position: 'relative' }}>
            <Image
              src={it.url}
              width={80}
              height={80}
              style={{ objectFit: 'cover', borderRadius: 6 }}
            />
            {editable ? (
              <Popconfirm
                title="¿Eliminar foto?"
                onConfirm={() => handleDelete(it.id)}
                okText="Sí"
                cancelText="No"
              >
                <Button
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  style={{ position: 'absolute', top: 2, right: 2 }}
                />
              </Popconfirm>
            ) : null}
          </div>
        ))}
      </Space>
    </Image.PreviewGroup>
  );
}

export default HallazgoFotosGallery;
